
export const ASYNC_FETCH = 'ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ASYNC_FETCH_INVALIDATE';
export const UPDATE_PLANS = 'UPDATE_PLANS';
export const UPDATE_PLANSOVERVIEW = 'UPDATE_PLANSOVERVIEW';
export const UPDATE_PACKAGESELECTION = 'UPDATE_PACKAGESELECTION';
export const UPDATE_ADDONS = 'UPDATE_ADDONS';
export const UPDATE_ADDONSCBAND = 'UPDATE_ADDONSCBAND';
export const UPDATE_SETUP = 'UPDATE_SETUP';
export const UPDATE_COVID = 'UPDATE_COVID';
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CHECKOUT = 'UPDATE_CHECKOUT';
export const UPDATE_CONTACTINFO = 'UPDATE_CONTACTINFO';
export const UPDATE_CREDITCHECK = 'UPDATE_CREDITCHECK';
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT';
export const UPDATE_SHIPPING = 'UPDATE_SHIPPING';
export const UPDATE_TOS = 'UPDATE_TOS';
export const UPDATE_REVIEWORDER = 'UPDATE_REVIEWORDER';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const UPDATE_CURRENT_VIEW = 'UPDATE_CURRENT_VIEW';
export const UPDATE_CREDITSTATUS = 'UPDATE_CREDITSTATUS';
export const UPDATE_ORDERREVIEW = 'UPDATE_ORDERREVIEW';
